import Text from "@/atoms-react/text/Text.react.tsx";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type TextWithIconProps = {
  children?: React.ReactNode;
  conditionValidate?: boolean;
  suffixIcon?: ReactNode | ReactNode[];
  iconColor?: string;
  textColor?: string;
} & React.ComponentPropsWithoutRef<"div">;

export default function TextWithIcon(props: TextWithIconProps) {
  const { iconColor = "text-primary" } = props;

  const conditionStyle =
    props.conditionValidate !== undefined
      ? props.conditionValidate
        ? "text-green-500 "
        : "text-slate-400 "
      : "";

  return (
    <div className={twMerge("flex gap-2", props.className)}>
      <div className={`${conditionStyle} h-6 min-h-6 w-6 min-w-6` + iconColor}>
        {props.suffixIcon}
      </div>
      <Text type="info" className={`${conditionStyle} font-medium` + props.textColor}>
        {props.children}
      </Text>
    </div>
  );
}
